<div class="border border-light border-5 rounded bg-light h-100">
	<div class="row mt-2 mb-3 text-center justify-content-center">
		<!-- <i class="bi bi-envelope-fill fs-1" aria-hidden="true"></i> -->
		<span
			*ngIf="listNotification.length > 0"
			class="theme-main-color fw-bold fs-4"
		>
			Nouveau{{ manyNewMessages ? 'x' : '' }} message{{
				manyNewMessages ? 's' : ''
			}}</span
		><span
			*ngIf="listNotification.length === 0"
			class="theme-main-color fw-bold fs-4"
		>
			Pas de nouveaux messages
		</span>
	</div>
	<div class="row">
		<div class="row" *ngFor="let notif of listNotification">
			<div class="row">
				<span class="theme-main-color"
					>Vous avez
					<span class="theme-main-color fw-bold"
						>{{ notif.messagesNumber }}
					</span>
					nouveau{{ notif.messagesNumber > 1 ? 'x' : '' }} message{{
						notif.messagesNumber > 1 ? 's' : ''
					}}
					de
					<span class="theme-main-color fw-bold">{{
						notif.firstNameSender + ' ' + notif.lastNameSender
					}}</span></span
				>
			</div>
		</div>
	</div>
</div>
